import React from "react";
import { Grid, TextField, MenuItem } from "@mui/material";
import { Resistor } from "../../models/signalUsers/resistor.ts";
import { Signal } from "../../models/signal.ts";
import { getSignalLabelFromList } from "../../utils/signalUtils.ts";
import { useResistorOptions } from "../../hooks/useResistorOptions.ts"
import { formatResistorString } from "../../utils/resistor.ts"

interface Props {
  data: Resistor;
  setIsValid: (isValid: boolean) => void;
  onChange: (relais: Resistor) => void;
  signalOptions: Signal[];
}

const EditResistorForm: React.FC<Props> = ({ data, setIsValid, onChange, signalOptions }) => {
  const { options } = useResistorOptions();

  const handleChange = (resistor: Resistor) => {
    onChange(resistor);
    if (resistor.pin1.id === resistor.pin2.id || resistor.pin1.id === "" || resistor.pin2.id === "" || resistor.resistance <= 0) {
      setIsValid(false);
    } else {
      setIsValid(true);
    }
  };

  return (
    <Grid container spacing={2} sx={{ mt: 2 }}>
      <Grid size={{ xs: 12, sm: 6 }}>
        <TextField
          select fullWidth label="Pin 1"
          value={data.pin1.id}
          error={data.pin1.id === "" || data.pin1.id === data.pin2.id}
          onChange={(e) => {
            const selected = signalOptions.find(s => s.id === e.target.value);
            if (selected) handleChange({ ...data, pin1: selected });
          }}
        >
          {signalOptions.map(opt => (
            <MenuItem key={opt.id} value={opt.id}>{getSignalLabelFromList(opt.id, signalOptions)}</MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <TextField
          select fullWidth label="Pin 2"
          value={data.pin2.id}
          error={data.pin2.id === "" || data.pin1.id === data.pin2.id}
          onChange={(e) => {
            const selected = signalOptions.find(s => s.id === e.target.value);
            if (selected) handleChange({ ...data, pin2: selected });
          }}
        >
          {signalOptions.map(opt => (
            <MenuItem key={opt.id} value={opt.id}>{getSignalLabelFromList(opt.id, signalOptions)}</MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid size={4}>
        <TextField
          select
          fullWidth
          label="Widerstand"
          error={data.resistance === 0}
          value={options.includes(data.resistance) ? data.resistance : ""}
          onChange={(e) =>
            handleChange({
              ...data,
              resistance: parseFloat(e.target.value),
            })
          }
        >
          {(options || []).map((r) => (
            <MenuItem key={r} value={r}> {
              formatResistorString(r)
            }
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid size={4}>
        <TextField
          select
          fullWidth
          label="Leistung"
          value={data.power}
          onChange={(e) => handleChange({ ...data, power: e.target.value as Resistor["power"] })}
        >
          <MenuItem value="0,25W">0,25 W</MenuItem>
          <MenuItem value="0,5W">0,5 W</MenuItem>
        </TextField>
      </Grid>
      <Grid size={4}>
        <TextField
          select
          fullWidth
          label="Toleranz"
          value={data.tolerance}
          onChange={(e) => handleChange({ ...data, tolerance: e.target.value as Resistor["tolerance"] })}
        >
          <MenuItem value="1%">1%</MenuItem>
          <MenuItem value="0,5%">0,5%</MenuItem>
          <MenuItem value="0,1%">0,1%</MenuItem>
        </TextField>
      </Grid>
    </Grid>
  );
};

export default EditResistorForm;
